
import { useState, useEffect } from 'react';
import { Notification } from '../types';

// Mock data for notifications
const mockNotifications: Notification[] = [
  {
    id: '1',
    title: 'Team Project Updates',
    message: 'The UI Design project has been updated with new requirements.',
    timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(), // 30 minutes ago
    read: false,
    type: 'info',
    link: '/teams/1/projects/2',
    entityId: '2',
    entityType: 'project',
  },
  {
    id: '2',
    title: 'Resource Allocation Alert',
    message: 'Sarah Thompson is overallocated by 20% this sprint.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(), // 2 hours ago
    read: false,
    type: 'alert',
    link: '/project/5/team',
    entityId: '5',
    entityType: 'project',
  },
  {
    id: '3',
    title: 'Task Deadline Approaching',
    message: 'The "Implement API Integration" task is due in 2 days.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5).toISOString(), // 5 hours ago
    read: true,
    type: 'warning',
    entityId: '8',
    entityType: 'task',
  },
  {
    id: '4',
    title: 'New Team Member',
    message: 'James Wilson has been added to the Development team.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(), // 1 day ago
    read: true,
    type: 'info',
    link: '/teams/3',
    entityId: '3',
    entityType: 'team',
  },
  {
    id: '5',
    title: 'Sprint Completed',
    message: 'The current sprint has been successfully completed with 95% of tasks finished.',
    timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2).toISOString(), // 2 days ago
    read: false,
    type: 'success',
    link: '/analytics',
  },
];

export function useNotifications() {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API fetch delay
    const timer = setTimeout(() => {
      setNotifications(mockNotifications);
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const markAsRead = (id: string) => {
    setNotifications(prevNotifications =>
      prevNotifications.map(notification =>
        notification.id === id ? { ...notification, read: true } : notification
      )
    );
  };

  const markAllAsRead = () => {
    setNotifications(prevNotifications =>
      prevNotifications.map(notification => ({ ...notification, read: true }))
    );
  };

  return {
    notifications,
    loading,
    markAsRead,
    markAllAsRead,
  };
}
